// extracted by mini-css-extract-plugin
export default {"CardTitle":"CardTitle_CardTitle__R7wqg","CardTitle_large":"CardTitle_CardTitle_large__ZptZB","CardTitle_medium":"CardTitle_CardTitle_medium__cJKr9"};